import type { ImgHTMLAttributes } from 'react';
import { useState } from 'react';

interface Props extends ImgHTMLAttributes<HTMLImageElement> {}

const ImageComponent = ({ src, alt = 'Image', ...rest }: Props) => {
	const [imageError, setImageError] = useState(false);

	const handleError = () => {
		setImageError(true);
	};

	const placeholderSvg = `data:image/svg+xml;base64,${btoa(`
		<svg width="200" height="200" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
			<rect width="200" height="200" fill="#f0f0f0" rx="4"/>
			<g transform="translate(60, 50)">
				<rect x="10" y="10" width="60" height="50" rx="2" fill="#c0c0c0"/>
				<circle cx="30" cy="30" r="8" fill="#d8d8d8"/>
				<polygon points="10,60 35,40 50,52 70,35 70,60" fill="#d8d8d8"/>
			</g>
			<text x="50%" y="82%" text-anchor="middle" fill="#999" font-family="DM Sans, sans-serif" font-size="11">
				No image
			</text>
		</svg>
	`)}`;

	return (
		<img
			src={imageError || !src ? placeholderSvg : src}
			alt={alt}
			onError={handleError}
			{...rest}
		/>
	);
};

export default ImageComponent;
